import { pdfjs } from 'react-pdf'
import { setupPdfWorker } from './setupPdfWorker'

setupPdfWorker(pdfjs)

export const convertPdfToImages = async pdfBase64 => {
  const pdfData = atob(pdfBase64)
  const uint8Array = new Uint8Array(pdfData.length)
  for (let i = 0; i < pdfData.length; i++) {
    uint8Array[i] = pdfData.charCodeAt(i)
  }

  const pdf = await pdfjs.getDocument({ data: uint8Array }).promise
  const images = []

  for (let i = 0; i < pdf.numPages; i++) {
    const page = await pdf.getPage(i + 1)
    const viewport = page.getViewport({ scale: 1.5 })
    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    canvas.height = viewport.height
    canvas.width = viewport.width
    await page.render({ canvasContext: ctx, viewport }).promise
    images.push(canvas.toDataURL('image/png'))
  }

  return images
}
